import React, { useState, useEffect } from 'react';
import { User as UserIcon } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { User } from '@supabase/supabase-js';

const UserProfile = ({ darkSidebar = false }: { darkSidebar?: boolean }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
      setLoading(false);
    };
    getUser();
  }, []);

  if (loading) {
    return (
      <div
        className="animate-pulse h-14 w-full rounded-lg"
        style={{ background: darkSidebar ? 'rgba(255,255,255,0.06)' : undefined }}
      />
    );
  }

  if (!user) return null;

  const displayName = user.user_metadata?.username || user.email || '';
  const getInitials = (name: string) => name.substring(0, 2).toUpperCase();

  if (darkSidebar) {
    return (
      <div
        className="flex items-center justify-center md:justify-start gap-3 p-0 md:p-3 rounded-lg transition-colors"
        style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.06)' }}
      >
        <div className="h-9 w-9 md:h-10 md:w-10 rounded-full flex items-center justify-center font-semibold text-xs md:text-sm flex-shrink-0" style={{ background: '#16a085', color: '#EDF4F2' }}>
          {getInitials(displayName)}
        </div>
        <div className="hidden md:block flex-1 min-w-0">
          <p className="text-sm font-medium truncate" style={{ color: '#EDF4F2' }}>{displayName}</p>
          <p className="text-xs" style={{ color: '#5A7D75' }}>Account</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center md:justify-start gap-3 p-0 md:p-3 rounded-lg md:bg-muted md:border md:border-border md:hover:bg-accent transition-colors">
      <div className="h-9 w-9 md:h-10 md:w-10 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white font-semibold text-xs md:text-sm flex-shrink-0">
        {getInitials(displayName)}
      </div>
      <div className="hidden md:block flex-1 min-w-0">
        <p className="text-sm font-medium text-foreground truncate">{displayName}</p>
        <p className="text-xs text-muted-foreground">Account</p>
      </div>
    </div>
  );
};

export default UserProfile;
